"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getAnchor = getAnchor;
exports.isHorizontal = isHorizontal;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _integerPropType = _interopRequireDefault(require("@mui/utils/integerPropType"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _RtlProvider = require("@mui/system/RtlProvider");
var _Modal = _interopRequireDefault(require("../Modal"));
var _Slide = _interopRequireDefault(require("../Slide"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _rootShouldForwardProp = _interopRequireDefault(require("../styles/rootShouldForwardProp"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _drawerClasses = require("./drawerClasses");
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
var overridesResolver = function(props, styles) {
    var ownerState = props.ownerState;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, anchor = ownerState.anchor, variant = ownerState.variant;
    var slots = {
        root: [
            'root',
            "anchor".concat((0, _capitalize.default)(anchor))
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            "paperAnchor".concat((0, _capitalize.default)(anchor)),
            variant !== 'temporary' && "paperAnchorDocked".concat((0, _capitalize.default)(anchor))
        ]
    };
    return (0, _composeClasses.default)(slots, _drawerClasses.getDrawerUtilityClass, classes);
};
var DrawerRoot = (0, _zeroStyled.styled)(_Modal.default, {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: overridesResolver
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        zIndex: (theme.vars || theme).zIndex.drawer
    };
}));
var DrawerDockedRoot = (0, _zeroStyled.styled)('div', {
    shouldForwardProp: _rootShouldForwardProp.default,
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: overridesResolver
})({
    flex: '0 0 auto'
});
var DrawerPaper = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.paper,
            styles["paperAnchor".concat((0, _capitalize.default)(ownerState.anchor))],
            ownerState.variant !== 'temporary' && styles["paperAnchorDocked".concat((0, _capitalize.default)(ownerState.anchor))]
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchor === 'left' && ownerState.variant !== 'temporary';
                },
                style: {
                    borderRight: "1px solid ".concat((theme.vars || theme).palette.divider)
                }
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchor === 'top' && ownerState.variant !== 'temporary';
                },
                style: {
                    borderBottom: "1px solid ".concat((theme.vars || theme).palette.divider)
                }
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchor === 'right' && ownerState.variant !== 'temporary';
                },
                style: {
                    borderLeft: "1px solid ".concat((theme.vars || theme).palette.divider)
                }
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary';
                },
                style: {
                    borderTop: "1px solid ".concat((theme.vars || theme).palette.divider)
                }
            }
        ]
    };
}));
var oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function isHorizontal(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function getAnchor(param, anchor) {
    var direction = param.direction;
    return direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ var Drawer = /*#__PURE__*/ React.forwardRef(function Drawer(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    var theme = (0, _zeroStyled.useTheme)();
    var isRtl = (0, _RtlProvider.useRtl)();
    var defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    var tmp = props.anchor, anchorProp = tmp === void 0 ? 'left' : tmp, BackdropProps = props.BackdropProps, children = props.children, className = props.className, _props_elevation = props.elevation, elevation = _props_elevation === void 0 ? 16 : _props_elevation, _props_hideBackdrop = props.hideBackdrop, hideBackdrop = _props_hideBackdrop === void 0 ? false : _props_hideBackdrop, tmp1 = props.ModalProps, _ref = tmp1 === void 0 ? {} : tmp1, BackdropPropsProp = _ref.BackdropProps, onClose = props.onClose, _props_open = props.open, open = _props_open === void 0 ? false : _props_open, _props_PaperProps = props.PaperProps, PaperProps = _props_PaperProps === void 0 ? {} : _props_PaperProps, SlideProps = props.SlideProps, // eslint-disable-next-line react/prop-types
    TransitionComponent = props.TransitionComponent, _props_transitionDuration = props.transitionDuration, transitionDuration = _props_transitionDuration === void 0 ? defaultTransitionDuration : _props_transitionDuration, _props_variant = props.variant, variant = _props_variant === void 0 ? 'temporary' : _props_variant, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, ModalProps = _object_without_properties(props.ModalProps, [
        "BackdropProps"
    ]), other = _object_without_properties(props, [
        "anchor",
        "BackdropProps",
        "children",
        "className",
        "elevation",
        "hideBackdrop",
        "ModalProps",
        "onClose",
        "open",
        "PaperProps",
        "SlideProps",
        "TransitionComponent",
        "transitionDuration",
        "variant",
        "slots",
        "slotProps"
    ]);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    var mounted = React.useRef(false);
    React.useEffect(function() {
        mounted.current = true;
    }, []);
    var anchorInvariant = getAnchor({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    var anchor = anchorProp;
    var ownerState = _object_spread(_object_spread_props(_object_spread({}, props), {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }), other);
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: _object_spread({
            transition: TransitionComponent
        }, slots),
        slotProps: _object_spread_props(_object_spread({
            paper: PaperProps,
            transition: SlideProps
        }, slotProps), {
            backdrop: (0, _utils.mergeSlotProps)(slotProps.backdrop || _object_spread({}, BackdropProps, BackdropPropsProp), {
                transitionDuration: transitionDuration
            })
        })
    };
    var _ref1 = _sliced_to_array((0, _useSlot.default)('root', {
        ref: ref,
        elementType: DrawerRoot,
        className: (0, _clsx.default)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: _object_spread({}, externalForwardedProps, other, ModalProps),
        additionalProps: {
            open: open,
            onClose: onClose,
            hideBackdrop: hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    }), 2), RootSlot = _ref1[0], rootSlotProps = _ref1[1];
    var _ref2 = _sliced_to_array((0, _useSlot.default)('paper', {
        elementType: DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, _clsx.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true
        }
    }), 2), PaperSlot = _ref2[0], paperSlotProps = _ref2[1];
    var _ref3 = _sliced_to_array((0, _useSlot.default)('docked', {
        elementType: DrawerDockedRoot,
        ref: ref,
        className: (0, _clsx.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    }), 2), DockedSlot = _ref3[0], dockedSlotProps = _ref3[1];
    var _ref4 = _sliced_to_array((0, _useSlot.default)('transition', {
        elementType: _Slide.default,
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            in: open,
            direction: oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current
        }
    }), 2), TransitionSlot = _ref4[0], transitionSlotProps = _ref4[1];
    var drawer = /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperSlot, _object_spread_props(_object_spread({}, paperSlotProps), {
        children: children
    }));
    if (variant === 'permanent') {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DockedSlot, _object_spread_props(_object_spread({}, dockedSlotProps), {
            children: drawer
        }));
    }
    var slidingDrawer = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, _object_spread_props(_object_spread({}, transitionSlotProps), {
        children: drawer
    }));
    if (variant === 'persistent') {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DockedSlot, _object_spread_props(_object_spread({}, dockedSlotProps), {
            children: slidingDrawer
        }));
    }
    // variant === temporary
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, _object_spread_props(_object_spread({}, rootSlotProps), {
        children: slidingDrawer
    }));
});
process.env.NODE_ENV !== "production" ? Drawer.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Side from which the drawer will appear.
   * @default 'left'
   */ anchor: _propTypes.default.oneOf([
        'bottom',
        'left',
        'right',
        'top'
    ]),
    /**
   * @ignore
   */ BackdropProps: _propTypes.default.object,
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The elevation of the drawer.
   * @default 16
   */ elevation: _integerPropType.default,
    /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */ hideBackdrop: _propTypes.default.bool,
    /**
   * Props applied to the [`Modal`](https://mui.com/material-ui/api/modal/) element.
   * @default {}
   */ ModalProps: _propTypes.default.object,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: _propTypes.default.func,
    /**
   * If `true`, the component is shown.
   * @default false
   */ open: _propTypes.default.bool,
    /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @deprecated use the `slotProps.paper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ PaperProps: _propTypes.default.object,
    /**
   * Props applied to the [`Slide`](https://mui.com/material-ui/api/slide/) element.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ SlideProps: _propTypes.default.object,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        backdrop: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        docked: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        paper: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        transition: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        backdrop: _propTypes.default.elementType,
        docked: _propTypes.default.elementType,
        paper: _propTypes.default.elementType,
        root: _propTypes.default.elementType,
        transition: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.shape({
            appear: _propTypes.default.number,
            enter: _propTypes.default.number,
            exit: _propTypes.default.number
        })
    ]),
    /**
   * The variant to use.
   * @default 'temporary'
   */ variant: _propTypes.default.oneOf([
        'permanent',
        'persistent',
        'temporary'
    ])
} : void 0;
var _default = exports.default = Drawer;
